import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({
  discountBreakdown: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)'
  },
  discountRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px'
  },
  discountLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  discountAmount: {
    fontWeight: 600
  }
}, sections), helpers), {}, {
  pageWrapper: {
    paddingTop: '32px'
  },
  subscriptionOverviewHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '8px'
  },
  subscriptionOverviewTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px'
  },
  subscriptionOverviewStartDate: {
    color: palette.shades[900],
    fontWeight: 600
  },
  subscriptionTermBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
    padding: '6px 16px',
    borderRadius: '999px',
    backgroundColor: '#E8F5E9',
    color: '#2E7D32',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: 1.4
  },
  subscriptionTermBadgeDot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  section: {
    padding: '24px 32px',
    background: palette.brandGradients.fade,
    borderRadius: '2px 2px 0 0',
    border: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '32px',
    '& + $subSection': {
      borderTop: 'none'
    }
  },
  subSection: {
    padding: '24px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: "1px solid ".concat(palette.shades[300]),
    '& + &': {
      borderTop: 'none'
    },
    '&:last-child': {
      borderRadius: '0 0 2px 2px'
    }
  },
  couponSection: {
    borderTop: 'none'
  },
  tabletSubsection: {
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  promocode: {
    [breakpointsFunc.breakpoints.down('md')]: {
      marginBottom: '18px'
    }
  },
  paymentDescription: {
    marginRight: '24px'
  },
  paymentPaper: {
    marginTop: '40px !important'
  },
  codeFieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('md')]: {
      marginTop: '24px'
    }
  },
  codeField: {
    width: '240px',
    marginRight: '10px'
  },
  cancelSubscriptionContainer: {
    marginTop: '40px',
    paddingTop: '40px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  cancelSubscription: {
    padding: '24px 32px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiButton-actionButton': {
      border: "1px solid ".concat(palette.shades[300]),
      flexShrink: '0',
      marginLeft: '24px'
    },
    '& .MuiButton-root': {
      marginTop: '8px'
    }
  }
}));
export default useStyles;